<template>
  <div class="addApp">
    <!--新增-->
    <el-dialog
      :title="$t('app.insertTitle')"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      width="400px"
    >
      <el-form
        label-width="auto"
        :rules="rules"
        :model="addInfo"
        ref="insertDialog"
        :label-position="'right'"
      >
        <el-form-item :label="$t('app.applicationName')" prop="applicationName">
          <el-input
            v-model="addInfo.applicationName"
            :placeholder="$t('menu.namePlaceholder')"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('menu.remark')" prop="remark">
          <el-input
            v-model="addInfo.remark"
            :placeholder="$t('menu.remarkPlaceholder')"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="addSure()">{{
          $t('dialog.confirm')
        }}</el-button>
        <el-button @click="dialogAdd = false">{{ $t('dialog.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import API from '@/api/systemManage/application.js';
  export default {
    name: 'addApp',
    data() {
      return {
        dialogAdd: false,
        loading: false,
        addInfo: {
          applicationName: '',
          remark: '',
        },
      };
    },
    computed: {
      rules() {
        // 校验特殊字符
        var specialValidate = (rule, value, callback) => {
          var reg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/;
          if (value.match(reg)) {
            callback(new Error(this.$t('menu.emoticons')));
          } else {
            callback();
          }
        };
        return {
          applicationName: [
            {
              required: true,
              message: this.$t('menu.menunameNotEmpty'),
              trigger: 'blur',
            },
            {
              min: 1,
              max: 40,
              message: this.$t('menu.menunameWordNumber'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
          remark: [
            {
              min: 1,
              max: 400,
              message: this.$t('menu.remarkWordNumber'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
        };
      },
    },
    methods: {
      openDialog(flag) {
        if (this.$refs['insertDialog']) {
          this.$refs['insertDialog'].resetFields();
        }
        this.loading = false;
        this.dialogAdd = flag;
      },
      //保存
      addSure() {
        this.$refs.insertDialog.validate((valid) => {
          if (valid && !this.loading) {
            this.loading = true;
            this.$axios.post(API.ADD_APP_API, this.addInfo).then((res) => {
              this.loading = false;
              if (0 != res.data.code) {
                this.$alert(res.data.msg);
              } else {
                this.dialogAdd = false;
                this.$emit('getData');
                this.$message({
                  showClose: true,
                  message: res.data.msg || this.$t('message.success'),
                  type: 'success',
                });
              }
            });
          } else {
            return false;
          }
        });
      },
    },
  };
</script>
